export const enSharedApps = {
  loadingAria: "Loading shared app",
  unavailableTitle: "Link unavailable",
  // Deliberately one message for every rejection (unknown code, expired, revoked, unpublished) —
  // it mirrors the backend's single opaque 404 and reveals nothing to someone probing codes.
  unavailable: "This link is no longer available.",
  // Same shape as publishedApps' view.snapshot block, so the shared picker takes identical props
  // from either page. `caption` covers the case where no picker renders and nothing else would tell
  // the viewer the numbers are frozen.
  snapshot: {
    selectAria: "Choose a snapshot to view",
    live: "Live data",
    caption: "{{name}}",
  },
} as const;
